import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-animation"
}

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TopScoringListSelector from '@/components/widgets/public/TopScoringListSelector.vue'
import { useTopScoringListsStore } from '@/store/public/top-scoring-lists'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopScoringListSelectionView',
  setup(__props) {

const router = useRouter()
const topScoringLists = useTopScoringListsStore()

const errorMessage = ref<string | null>()
const isLoading = ref<boolean>(false)

onMounted(async (): Promise<void> => {
  isLoading.value = true

  try {
    await topScoringLists.fetch()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching available top lists: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

async function selectList(id: number): Promise<void> {
  await router.push({ path: `/top-scoring-lists/${id}` })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('top-scoring-lists.selection-view-title')), 1),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BusyIndicator)
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 1,
            message: errorMessage.value,
            "is-danger": ""
          }, null, 8, ["message"]))
        : (_openBlock(), _createBlock(TopScoringListSelector, {
            key: 2,
            "available-lists": _unref(topScoringLists).available,
            onSelectList: selectList
          }, null, 8, ["available-lists"]))
  ]))
}
}

})